
import React, { useEffect, useState } from 'react';
import { api_bd_nr } from '../../../services/Api.js';
import ModalStateLess from '../../ModalStateLess/index.js';

import Avatar from '../Avatar.js';
import Form from '../Form.js';
import { Settings, TicketPlus, TicketX, TicketCheck, Ticket } from 'lucide-react'
import ConfigChart from '../ConfigChart.js';
import Ranking from '../Ranking/index.js';
import Card from '../Cards/index.js';
import LineChart from '../LineChart/index.js';
import { createDaysOfMonthObject } from '../../../util/fns.js';


const DashboardView = (props) => {
    const [modalData, setModalData] = useState({ show: false, content: <></>, hideModal: () => { } })
    const [modalData2, setModalData2] = useState({ show: false, content: <></>, hideModal: () => { } })
    const [data, setData] = useState([])
    const [actualMonth, setActualMonth] = useState(new Date().getMonth() + 1)

    const [cardsChartData, setCardsChartData] = useState({
        newTickets: 'Carregando...',
        createdTickets: 'Carregando...',
        closedTickets: 'Carregando...',
        pendingTickets: 'Carregando...',
        // dataObjectOpened: createDaysOfMonthObject(),
        // dataObjectClosed: createDaysOfMonthObject()
    })

    const [chartData, setChartData] = useState({ opened: createDaysOfMonthObject(actualMonth - 1, new Date().getFullYear()), closed: createDaysOfMonthObject(actualMonth - 1, new Date().getFullYear()) });

    const monthList = [
        { label: "Janeiro", value: 1 },
        { label: "Fevereiro", value: 2 },
        { label: "Março", value: 3 },
        { label: "Abril", value: 4 },
        { label: "Maio", value: 5 },
        { label: "Junho", value: 6 },
        { label: "Julho", value: 7 },
        { label: "Agosto", value: 8 },
        { label: "Setembro", value: 9 },
        { label: "Outubro", value: 10 },
        { label: "Novembro", value: 11 },
        { label: "Dezembro", value: 12 },
    ]

    const closeModal = () => {
        setModalData({ show: false, content: <></>, hideModal: () => { } })
    };

    const closeModal2 = () => {
        setModalData2({ show: false, content: <></>, hideModal: () => { } })
    };

    const openModal = (_content = false) => {
        if (_content) {
            setModalData({ show: true, content: _content, hideModal: closeModal })
        }
    };

    const openModal2 = (_content = false) => {
        if (_content) {
            setModalData2({ show: true, content: _content, hideModal: closeModal2 })
        }
    };

    const saveData = (data, update) => {
        const d = new Date()
        const participants = data.map(el => {
            return ({
                ...el,
                name: el.name || el.nome,
                avatar: el.avatar || el.image_profile,
                id: el.id || el._id
            })
        })

        if (update) {
            api_bd_nr.put('/performance-radar?q=data', {
                month: String(d.getMonth() + 1).padStart(2, '0'),
                year: d.getFullYear(),
                participants
            })
                .then(({ data }) => {
                    // console.log('data: ', data)
                    loadData()
                })
                .catch((error) => {
                    console.log('save data error: ', error)
                })
        } else {
            api_bd_nr.post('/performance-radar?q=data', {
                month: String(d.getMonth() + 1).padStart(2, '0'),
                year: d.getFullYear(),
                participants
            })
                .then(({ data }) => {
                    // console.log('data: ', data)
                    loadData()
                })
                .catch((error) => {
                    console.log('save data error: ', error)
                })
        }

    }

    const loadTicketsPerMonth = (chartData) => {
        api_bd_nr.get(`/tickets/counterpermonth?m=${actualMonth}`)
            .then(({ data }) => {
                // console.log('data: ', data)
                if (data.length === 0) {
                    setCardsChartData({
                        newTickets: 0,
                        createdTickets: 0,
                        closedTickets: 0,
                        pendingTickets: 0
                    })
                    return
                }

                //create date of first day of month
                const d = new Date()
                d.setMonth(actualMonth - 1)
                d.setDate(1)
                d.setHours(0, 0, 0, 0)


                const dataObjectOpened = createDaysOfMonthObject(d.getMonth(), d.getFullYear())// objecto com todos os dias do mês
                const dataObjectClosed = createDaysOfMonthObject(d.getMonth(), d.getFullYear())// objecto com todos os dias do mês
                const orderedData = data.sort((a, b) => {
                    // Converte as strings de data para objetos Date, se necessário
                    const dataA = typeof a.createdAt === 'string' ? new Date(a.createdAt) : a.createdAt;
                    const dataB = typeof b.createdAt === 'string' ? new Date(b.createdAt) : b.createdAt;

                    // Compara as datas
                    // Se dataA for anterior a dataB, retorna um número negativo.
                    // Se dataA for posterior a dataB, retorna um número positivo.
                    // Se forem iguais, retorna 0.
                    return dataA - dataB;
                });

                orderedData.forEach(element => {
                    const createdAt = new Date(element.createdAt)
                    const updatedAt = new Date(element.updatedAt)
                    const solutionAt = new Date(element.data_solucao)
                    const state = element.situacao.titulo

                    if (createdAt >= d && dataObjectOpened?.[createdAt?.getDate()]) {
                        dataObjectOpened[createdAt.getDate()].qty += 1
                    }

                    if (solutionAt >= d && state.match(/fechado|solucionado/i) && dataObjectClosed?.[updatedAt?.getDate()]) {
                        dataObjectClosed[updatedAt.getDate()].qty += 1
                    }
                });



                const objData = {
                    newTickets: orderedData.filter(el => el.situacao.titulo === 'novo').length,
                    createdTickets: orderedData.filter(el => new Date(el.createdAt) >= d).length,
                    closedTickets: orderedData.filter(el => (new Date(el.data_solucao) >= d) && el.situacao.titulo.match(/fechado|solucionado/i)).length,
                    pendingTickets: orderedData.filter(el => el.situacao.titulo.match(/pendente|aguardando|janela_agendada|follow_up/i)).length,
                    // dataObjectOpened,
                    // dataObjectClosed
                }
                setCardsChartData(objData)

                setChartData({ opened: dataObjectOpened, closed: dataObjectClosed });

            }).catch((error) => {
                console.log('get data error: ', error)
            })
    }


    const loadData = () => {
        api_bd_nr.get(`/performance-radar?q=data&m=${actualMonth}`)
            .then(({ data }) => {
                // console.log('data: ', data)
                const participants = data?.[0]?.participants?.map((el, index) => {
                    return ({
                        ...el,
                        endIcon: (
                            <Avatar
                                src={el.avatar}
                                onClick={() => {
                                    if (props.loggedUser.id === el.id || props.loggedUser.nivel.match(/Super|Técnico-Admin/)) {
                                        openModal(<Form data={el} loggedUser={props.loggedUser} refreshData={loadData} openModal2={openModal2} closeModal2={closeModal2} />)
                                    } else {
                                        alert('Você não tem permissões para visualizar estas informações.')
                                    }
                                }}
                            />
                        ),
                        dataKey: index,
                        value: el.infractions.reduce((acc, currentData) => { return (acc + currentData?.point) }, 100)
                    })
                })

                // console.log('participants', participants)
                setData(participants || [])
            })
            .catch((error) => {
                console.log('get data error: ', error)
            })
    }

    useEffect(() => {
        setCardsChartData({
            newTickets: 'Carregando...',
            createdTickets: 'Carregando...',
            closedTickets: 'Carregando...',
            pendingTickets: 'Carregando...'
        })


        loadData()
        loadTicketsPerMonth(chartData)

        const interval = setInterval(() => {
            loadData()
            loadTicketsPerMonth(chartData)
        }, 300000)

        return () => {
            clearInterval(interval)
        }


    }, [actualMonth])

    const mediaVal = data.reduce((acc, currentItem) => {
        return acc + currentItem.value
    }, 0)

    const orderedData = data?.sort((a, b) => {
        if (b.value < a.value) {
            return -1;
        }
        if (b.value > a.value) {
            return 1;
        }

        // names must be equal
        return 0;
    })

    const filteredData = orderedData

    // console.log(window.innerWidth, window.innerHeight)

    return (
        <div style={{
            paddingTop: 20,
            display: 'flex',
            flexDirection: 'column',
            flexFlow: 1,
            width: '100%',
            height: 'calc(100dvh - 50px)',
            minHeight: 'calc(100dvh - 50px)',
            maxHeight: 'calc(100dvh - 50px)',
            overflowY: 'auto'
        }}
        >

            <ModalStateLess  {...modalData} />
            <ModalStateLess addZIndex={5} {...modalData2} />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 10, paddingRight: 20 }} >
                <div>
                    <span style={{ fontSize: '1.5em' }}>Selecione o mês: </span>
                    <select
                        style={{ fontSize: '1.5em' }}
                        value={actualMonth}
                        onChange={(e) => {
                            setActualMonth(parseInt(e.target.value))
                            // loadData()
                        }}
                    >
                        {
                            monthList.map(el => (
                                <option value={el.value}>{el.label}</option>
                            ))
                        }
                    </select>
                </div>

                {props?.loggedUser?.nivel?.match(/Super|Técnico-Admin/) &&
                    <Settings
                        alt="settings"
                        style={{ width: 30, height: 30, alignSelf: 'flex-end', cursor: 'pointer' }}
                        onClick={() => {
                            openModal(<ConfigChart
                                participantsList={data}
                                onSaveButtonClick={(val) => {
                                    // console.log('save data', data)
                                    saveData(val, data?.length > 0 ? true : false)
                                    closeModal()
                                }}
                            // onChangeParticipantList={(participantsList) => {
                            //     // console.log('lista de participantes, alterada', participantsList)
                            // }}
                            />);
                        }}
                    />
                }
            </div>



            <div className='flex flex-row w-full justify-center flex-wrap h-fit 3xl:'>

                <div className='flex flex-col items-center w-[60%] min-w-[300px]'>
                    <div className='w-full'>
                        <Ranking
                            containerTitle={<h3 className='font-bold text-2xl text-center mb-8 3xl:text-3xl 3xl:pl-[15%]'>TOP DESEMPENHO DO MÊS</h3>}
                            data={{
                                chartData: filteredData,//data,
                                first: orderedData?.[0] || {},
                                second: orderedData?.[1] || {},
                                third: orderedData?.[2] || {},
                                media: data?.length > 0 ? (mediaVal / data.length) : 0
                            }}
                        />
                    </div>
                </div>

                <div className='flex flex-col space-y-5 items-center md:items-end w-[40%] md:pr-[50px] min-w-[320px]'>
                    <Card
                        tailwindWidth="w-[300px] 3xl:w-[420px]"
                        title='Tickets abertos este mês'
                        value={String(cardsChartData.createdTickets).padStart(2, '0')}
                        icon={TicketPlus}
                        tailwindBgColor="bg-[#3c5ca6]"
                        tailwindTextColor="text-white"
                        tailwindIconColor=""
                        iconSize='w-[35px] h-[35px] 3xl:w-[50px] 3xl:h-[50px]'
                        tailwindValueTextSize='text-3xl 3xl:text-5xl'
                        tailwindTitleTextSize='text-sm 3xl:text-2xl'
                    />
                    <Card
                        tailwindWidth="w-[300px] 3xl:w-[420px]"
                        title='Tickets fechados este mês'
                        value={String(cardsChartData.closedTickets).padStart(2, '0')}
                        icon={TicketCheck}
                        tailwindBgColor="bg-gray-600"
                        tailwindTextColor="text-white"
                        tailwindIconColor=""
                        iconSize='w-[35px] h-[35px] 3xl:w-[50px] 3xl:h-[50px]'
                        tailwindValueTextSize='text-3xl 3xl:text-5xl'
                        tailwindTitleTextSize='text-sm 3xl:text-2xl'
                    />
                    <Card
                        tailwindWidth="w-[300px] 3xl:w-[420px]"
                        title='Tickets Pendentes'
                        value={String(cardsChartData.pendingTickets).padStart(2, '0')}
                        icon={TicketX}
                        tailwindBgColor="bg-orange-600"
                        tailwindTextColor="text-white"
                        tailwindIconColor=""
                        iconSize='w-[35px] h-[35px] 3xl:w-[50px] 3xl:h-[50px]'
                        tailwindValueTextSize='text-3xl 3xl:text-5xl'
                        tailwindTitleTextSize='text-sm 3xl:text-2xl'
                    />
                    <Card
                        tailwindWidth="w-[300px] 3xl:w-[420px]"
                        title='Tickets na fila NOVOS'
                        value={String(cardsChartData.newTickets).padStart(2, '0')}
                        icon={Ticket}
                        tailwindBgColor="bg-[#28a745]"
                        tailwindTextColor="text-white"
                        tailwindIconColor=""
                        iconSize='w-[35px] h-[35px] 3xl:w-[50px] 3xl:h-[50px]'
                        tailwindValueTextSize='text-3xl 3xl:text-5xl'
                        tailwindTitleTextSize='text-sm 3xl:text-2xl'
                    />
                </div>

            </div>
            <div className='h-[100%] w-[100%]'>
                <LineChart dataObject={chartData} tailwindWidth='w-full' tailwindHeight='h-[100%]' />
            </div>
        </div>
    );
};

export default DashboardView;
